import React, { useMemo } from 'react';
import { Pivot } from 'api';
import { useDispatch } from 'react-redux';
import { Button, Form } from 'antd';
import styles from './index.module.scss';
import ModifyPassword from 'lib/publicUsecase/ModifyPassword';
import { ModifyPasswordResStatus } from 'lib/publicUsecase/type';
import { getMobile, setAuthUserInfo } from 'data/storage';
import { noop } from 'lodash';
import { appMessageSuccess } from 'model/app';
import LoginMobileCaptchaItem from 'component/AuthForm/LoginMobileCaptchaItem';
import LoginMobileItem from 'component/AuthForm/LoginMobileItem';
import LoginPasswordItem from 'component/AuthForm/LoginPasswordItem';
import { getSessionId } from 'util/session';
import { useStore } from 'page/Login/component/useStore';
import MobileCaptcha from 'lib/publicUsecase/MobileCaptcha';
import useCountDown from 'util/countdown';

interface IProps {
  onSuccess: () => void;
}

interface FormData {
  mobile: string;
  password: string;
  confirmPassword: string;
  mobileCaptcha: string;
}

const ModifyPasswordComponent: React.FC<IProps> = ({ onSuccess }) => {
  const [form] = Form.useForm<FormData>();
  const dispatch = useDispatch();
  const { countDown, isDisposed, startCountDown } = useCountDown();
  const { formStore, stateStore, stateData, handleFromDataChange, handleStateDataChange } = useStore<FormData>(
    {
      mobile: getMobile(),
      mobileCaptcha: '',
      password: '',
      confirmPassword: ''
    },
    {
      modifyLoading: false,
      mobileCaptchaeLoading: false,
      mobileCaptchaeError: '',
      passwordError: ''
    }
  );

  function onFieldsChange() {
    const newData = form.getFieldsValue();
    handleFromDataChange(newData);
  }

  const modifyPassword = new ModifyPassword({
    API: {
      getSessionId,
      modifyPassword: (data: any) => Pivot.modifyPassword(data).toPromise()
    },
    formStore: formStore as any,
    stateStore
  });

  const mobileCaptchaInstance = new MobileCaptcha({
    API: {
      startCountDown,
      getMobileCaptcha: (mobile, type, slidingCaptcha) => Pivot.getMobileCaptchas(mobile, type, slidingCaptcha).toPromise()
    },
    state: stateStore
  });

  async function handleSumbit() {
    const formRes = await form.validateFields().catch(noop);
    if (!formRes) return;
    const res = await modifyPassword.fetchModifyPassword();
    if (!res) return;
    const { status, data } = res;
    if (status === ModifyPasswordResStatus.SUCCESS) {
      // 设置密码成功
      dispatch(appMessageSuccess('设置密码成功'));
      // 更新用户认证信息
      setAuthUserInfo({
        token: data.access_token
      });
      onSuccess && onSuccess();
    }
  }

  const onClickVerifyCode = (slidingCaptcha: any) => {
    const mobile = form.getFieldValue('mobile');
    mobileCaptchaInstance.getMobileCaptcha(mobile, 3, slidingCaptcha);
  };

  const handleCancel = () => {
    onSuccess && onSuccess();
  };

  const { mobile, password, mobileCaptcha, confirmPassword } = form.getFieldsValue();
  const submitBtnEnable = useMemo(() => {
    return mobile && password && mobileCaptcha && confirmPassword;
  }, [mobile, password, mobileCaptcha, confirmPassword]);

  // eslint-disable-next-line multiline-ternary
  return (
    <div className={styles.formWrapper}>
      <Form form={form} onFieldsChange={onFieldsChange} initialValues={formStore.value}>
        <LoginMobileItem name="mobile" disabled />
        {/* 验证码 */}
        <LoginMobileCaptchaItem
          name="mobileCaptcha"
          help={stateData.mobileCaptchaeError}
          onChange={() => {
            handleStateDataChange({ mobileCaptchaeError: '' });
          }}
          loading={stateData.mobileCaptchaeLoading}
          countDown={countDown}
          isDisposed={isDisposed}
          form={form}
          targetValication={'mobile'}
          onClick={onClickVerifyCode}
        />
        {/* 验证码end */}
        <LoginPasswordItem name="password" help={stateData.passwordError} type="new" />
        <LoginPasswordItem name="confirmPassword" type="confirm" />
        <div className={styles.buttonWrapper}>
          <Button className={styles.buttonCancel} disabled={stateData.modifyLoading} onClick={handleCancel}>
            取消
          </Button>
          <Button
            className={styles.buttonSubmit}
            loading={stateData.modifyLoading}
            disabled={!submitBtnEnable}
            type="primary"
            htmlType="submit"
            onClick={handleSumbit}
          >
            确定
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default ModifyPasswordComponent;
